import React, { useState, useEffect } from "react";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import { db } from "./firebase";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  addDoc,
} from "firebase/firestore";

function Inventory() {
  const user = auth.currentUser;
  const [items, setItems] = useState([]);
  const [newName, setNewName] = useState("");
  const [newQty, setNewQty] = useState("");
  const [newCategory, setNewCategory] = useState("Olive Oil");
  const [newCost, setNewCost] = useState(""); // NEW FIELD
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [selectedCategory, setSelectedCategory] = useState("All");

  const handleLogout = () => {
    signOut(auth).then(() => {
      window.location.href = "/";
    });
  };

  useEffect(() => {
    const loadInventory = async () => {
      const snapshot = await getDocs(collection(db, "inventory"));
      setItems(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };
    loadInventory();
  }, []);

  const updateQuantity = async (id, newQty) => {
    const ref = doc(db, "inventory", id);
    const today = new Date().toLocaleDateString();

    await updateDoc(ref, {
      quantity: parseInt(newQty),
      lastUpdatedBy: user?.email || "Unknown",
      lastUpdatedAt: today,
    });

    setItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              quantity: parseInt(newQty),
              lastUpdatedBy: user?.email || "Unknown",
              lastUpdatedAt: today,
            }
          : item
      )
    );
  };

  const handleAddItem = async () => {
    const today = new Date().toLocaleDateString();

    const docRef = await addDoc(collection(db, "inventory"), {
      name: newName,
      quantity: parseInt(newQty),
      category: newCategory,
      cost: parseFloat(newCost) || 0, // NEW FIELD
      lastUpdatedBy: user?.email || "Unknown",
      lastUpdatedAt: today,
    });

    setItems((prev) => [
      ...prev,
      {
        id: docRef.id,
        name: newName,
        quantity: parseInt(newQty),
        category: newCategory,
        cost: parseFloat(newCost) || 0,
        lastUpdatedBy: user?.email || "Unknown",
        lastUpdatedAt: today,
      },
    ]);

    setNewName("");
    setNewQty("");
    setNewCost("");
    setNewCategory("Olive Oil");
  };

  const filteredItems = items
    .filter((item) => {
      const matchesSearch = item.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const matchesCategory =
        selectedCategory === "All" || item.category === selectedCategory;
      return matchesSearch && matchesCategory;
    })
    .sort((a, b) => {
      if (sortBy === "name") {
        return a.name.localeCompare(b.name);
      } else if (sortBy === "quantity") {
        return b.quantity - a.quantity;
      } else if (sortBy === "value") {
        return (b.quantity * (b.cost || 0)) - (a.quantity * (a.cost || 0));
      } else {
        return 0;
      }
    });

  const totalValue = filteredItems.reduce(
    (sum, item) => sum + (item.quantity || 0) * (item.cost || 0),
    0
  );

  return (
    <div className="app-container">
      <button onClick={handleLogout} style={{ float: "right", marginBottom: "20px" }}>
        Logout
      </button>

      <h2>Inventory Management</h2>

      <div className="form-row">
        <label>New Item:</label>
        <input
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="e.g. Chili Oil"
        />
        <label>Qty:</label>
        <input
          type="number"
          value={newQty}
          onChange={(e) => setNewQty(e.target.value)}
          placeholder="0"
        />
        <label>Cost:</label>
        <input
          type="number"
          value={newCost}
          onChange={(e) => setNewCost(e.target.value)}
          placeholder="0.00"
        />
        <label>Category:</label>
        <select
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
        >
          <option value="Olive Oil">Olive Oil</option>
          <option value="Balsamic">Balsamic</option>
          <option value="Pasta">Pasta</option>
          <option value="Sauces">Sauces</option>
          <option value="Snacks">Snacks</option>
          <option value="Relish and Pickles">Relish and Pickles</option>
          <option value="Truffles">Truffles</option>
        </select>
        <button onClick={handleAddItem} disabled={!newName || !newQty}>
          Add Item
        </button>
      </div>

      <div className="form-row">
        <input
          type="text"
          placeholder="Search inventory..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ flexGrow: 1 }}
        />
        <label>Sort:</label>
        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
          <option value="name">Name (A–Z)</option>
          <option value="quantity">Quantity (High to Low)</option>
          <option value="value">Value (High to Low)</option>
        </select>
        <label>Filter:</label>
        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="All">All</option>
          <option value="Olive Oil">Olive Oil</option>
          <option value="Balsamic">Balsamic</option>
          <option value="Pasta">Pasta</option>
          <option value="Sauces">Sauces</option>
          <option value="Snacks">Snacks</option>
          <option value="Relish and Pickles">Relish and Pickles</option>
          <option value="Truffles">Truffles</option>
        </select>
      </div>

      {filteredItems.map((item) => {
        const itemValue = (item.quantity || 0) * (item.cost || 0);
        return (
          <div key={item.id} className="inventory-item">
            <strong>{item.name}</strong> ({item.category || "—"})<br />
            Qty: {item.quantity || 0} × ${item.cost?.toFixed(2) || "0.00"} ={" "}
            <strong>${itemValue.toFixed(2)}</strong>
            <input
              type="number"
              value={item.quantity}
              onChange={(e) => updateQuantity(item.id, e.target.value)}
              style={{ marginLeft: "10px" }}
            />
            <div className="meta">
              Last updated by: {item.lastUpdatedBy || "—"} <br />
              Date: {item.lastUpdatedAt || "—"}
            </div>
          </div>
        );
      })}

      <h3 style={{ marginTop: "30px" }}>
        Total Inventory Value: ${totalValue.toFixed(2)}
      </h3>
    </div>
  );
}

export default Inventory;

